// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"82127d92","648":"a41b2460","703":"e002b900","787":"26079c78"}[chunkId] + ".chunk.js";
};